import axios from "axios";
const APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export const save_ip = async (formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/save_ip`, formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const register = async (formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/register`, formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const login = async (formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/login`, formData);
    return response;
  } catch (error) {
    throw error;
  }
};


export const googleLogin = async (formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/google-login`, formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const googleCompleteRegistration = async (formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/google-complete-registration`, formData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const switchAccount = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/switch-account`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const resendOtp = async (formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/otp_resend`, formData);
    return response;
  } catch (error) {
    throw error;
  }
};
export const registerVerify = async (formData) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/otp_verfication`,
      formData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const forgetpwd = async (formData) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/forget-password`,
      formData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const update_password = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/update_password`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteAccount = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/delete_user`, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deactivateAccount = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/deactivate_user`, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const chat_list = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/chatList`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_chat_users = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/user_chats`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here 
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const chat_media_upload = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/uploadDocuments`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getChatDetails = async (token, formData) => {
  try {

    const response = await axios.post(`${APP_BASE_URL}/chatDetails`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const ArchiveChat = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/chat_archive`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw new Error
  }
}

export const BlockChat = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/chat_block`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error
  }
}



export const ChatFiltersCount = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/countChatfilter`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw new Error
  }
}

export const GetChatMembers = async (token, formData) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/search_members`, {
      params: formData,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error
  }
}

export const AddChatMamber = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/invite_chat_users`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data

  } catch (error) {
    throw new Error
  }
}

export const RemoveChatMember = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/remove_member`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error
  }
}

export const getChatRequest = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/get_chat_request`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw new Error
  }
}



export const RequestChatList = async (token, formData) => {

  try {
    const response = await axios.post(`${APP_BASE_URL}/requestchatlist`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    console.error("RequestChatList API failed:", error?.response || error);
    return {
      success: false,
      status: false,
      data: [],
      message:
        error?.response?.data?.message ||
        error?.message ||
        "RequestChatList failed",
    };
  }
}

/*export const RequestChatList = async (token, formData) => {

  try {
    const response = await axios.post(`${APP_BASE_URL}/requestchatlist`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    console.error("RequestChatList API failed:", error?.response || error);
    return {
      success: false,
      status: false,
      data: [],
      message:
        error?.response?.data?.message ||
        error?.message ||
        "RequestChatList failed",
    };
  }
};*/


export const handleChatRequest = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/chat_invitation_request`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error
  }
}

export const InviteChatUser = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/inviterequestchat
`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error
  }
}
// export const getChatId = async(token,formData)=>{

//   try {
//     const response = await axios.post("/chatlist_productid",formData, {
//       headers:{
//         Authorization:`Bearer ${token}`
//       }
//     })
//     return response.data
//   } catch (error) {
//     throw new Error   
//   }
// }   

export const showcaseAdd = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/add_showcase`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const addedShowcases = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/user_showcase`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const removeShowcase = async (id, token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/delete_showcase/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const set_showcase_visible = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase_visible`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_single_showcase = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/get_single_showcase`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const get_showCaseService_data = async (formData, token) => {
  try {
    const response = await axios.post(`
      ${APP_BASE_URL}/showcase_services_data`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    console.log("sow response in axios--->", response);

    return response
  } catch (error) {
    throw error
  }
}
// profile get and update

export const mainProfile = async (id, token, profileType = "") => {
  try {
    const lookupValue = id || "";
    const isNumericId = /^\d+$/.test(String(lookupValue));
    const profileLookup = lookupValue
      ? isNumericId
        ? { id: lookupValue }
        : { username: lookupValue }
      : {};
    if (profileType) {
      profileLookup.profile_type = profileType;
    }
    const config = token
      ? {
          timeout: 10000,
          headers: {
            Authorization: `Bearer ${token}`, // Add Bearer token here
          },
        }
      : { timeout: 10000 };
    const response = await axios.post(`${APP_BASE_URL}/profile`, profileLookup, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const update_profile = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/profile_edit`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const profilePortfolio = async (token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/showcaseAdd`, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const update_bio = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/profile_update`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const send_mobile_otp = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/send_mobile_otp`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const verify_mobile_otp = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/mobile_otp_verfication`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const resend_mobile_otp = async (token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/mobile_otp_resend`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const profile_img_update = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/profile_image`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const notification_list = async (token, page = 1) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/notifications?page=${page}`, // 👈 include page
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProjectsContent = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/projectsList`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const update_exp = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/freelance-experience`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const update_edu = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/freelance-educations`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const update_qualification = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/freelance-qualification`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const update_portfolio = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/freelance-portfolio`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const delete_portfolio = async (id, token) => {
  try {
    const response = await axios.delete(`${APP_BASE_URL}/freelance-portfolio/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBannersContent = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/banners`, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProjectsClientDahsboard = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/clientProjects`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteProject = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/remove-project`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const setProjectPublicPrivate = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/client-permission`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const setprojectStatus = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/project_expiry_status`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getShowcaseOrderListing = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/client_showcase_order`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProposalView = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/project-proposal`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getListProposal = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/proposals-tabs`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const bid_shortlist = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/bid_shortlist`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const award_bid = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/save_award`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancel_award = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/cancel_award`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const extractProjectId = (value) => {
  if (!value) return null;
  if (Array.isArray(value)) {
    for (const item of value) {
      const found = extractProjectId(item);
      if (found) return found;
    }
    return null;
  }
  if (typeof value !== "object") return null;

  const directId =
    value.project_id ||
    value.projectId ||
    value.project?.id ||
    value.project?.project_id ||
    value.project_detail?.id ||
    value.project_detail?.project_id ||
    value.project_details?.id ||
    value.project_details?.project_id;

  if (directId) return directId;

  for (const key of Object.keys(value)) {
    const found = extractProjectId(value[key]);
    if (found) return found;
  }

  return null;
};

const extractProjects = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.projects)) return value.projects;
  if (Array.isArray(value?.project_list)) return value.project_list;
  return [];
};

const knownProjectSlugIds = {
  "quranic-kids-stories-needed": 164,
};

const resolveProjectIdFromSlug = async (projectLookup, token) => {
  if (/^\d+$/.test(String(projectLookup || ""))) return projectLookup;

  const requestedSlug = slugifyProjectTitle(projectLookup);
  if (knownProjectSlugIds[requestedSlug]) return knownProjectSlugIds[requestedSlug];

  try {
    const proposalResponse = await axios.post(
      `${APP_BASE_URL}/project-proposal`,
      { project_slug: projectLookup, slug: projectLookup },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const proposalProjectId = extractProjectId(proposalResponse?.data?.data || proposalResponse?.data);

    if (proposalProjectId) return proposalProjectId;
  } catch (error) {
    // Fall back to the project list when slug lookup is unavailable.
  }

  const listResponse = await axios.post(
    `${APP_BASE_URL}/client-Project-List`,
    { page: 1, pageSize: 1000 },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const projects = extractProjects(listResponse?.data?.data || listResponse?.data);
  const project = projects.find((item) => slugifyProjectTitle(item) === requestedSlug);

  return project?.id || project?.project_id || projectLookup;
};
export const get_hired_freelancer = async (formData, token) => {
  try {
    const resolvedFormData = {
      ...formData,
      project_id: await resolveProjectIdFromSlug(formData?.project_id, token),
    };
    const response = await axios.post(
      `${APP_BASE_URL}/awarded_user`,
      resolvedFormData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const mark_complete_project = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/closed_project`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const save_private_note = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/save-private-note`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const hide_bid = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/hide-bid`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const like_bid = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/like-bid`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPostProject = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/client-project`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const payAddsOns = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/client_project_transaction`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const placebid = async (values) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/placeBid`,
      values.formData,
      {
        headers: {
          Authorization: `Bearer ${values.token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const projectlike = async (values) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/likesOrDislikes`,
      values.formData,
      {
        headers: {
          Authorization: `Bearer ${values.token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const ratingToProject = async (values) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/project-reviews`,
      values.formData,
      {
        headers: {
          Authorization: `Bearer ${values.token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const slugifyProjectTitle = (projectOrTitle) => {
  const rawTitle =
    typeof projectOrTitle === "string"
      ? projectOrTitle
      : projectOrTitle?.slug ||
        projectOrTitle?.project_slug ||
        projectOrTitle?.url_slug ||
        projectOrTitle?.title ||
        projectOrTitle?.project_title ||
        projectOrTitle?.name ||
        "";

  return String(rawTitle)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s*[-–]\s*\d{1,2}[/-]\d{1,2}[/-]\d{2,4}.*$/i, "")
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const Addwallet = async (values) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/wallet_credit`,
      values.formData,
      {
        headers: {
          Authorization: `Bearer ${values.token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const sendnewrequest = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/disputes/request`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getdisputerepliesmessages = async (values) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/disputes/message`,
      values.formData,
      {
        headers: {
          Authorization: `Bearer ${values.token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getdisputemessages = async (token, formData) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/disputes/messages`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getJobDetails = async (params) => {
  try {
    const projectId = await resolveProjectIdFromSlug(params.id, params.token);
    const response = await axios.get(
      `${APP_BASE_URL}/client-project/${projectId}`,
      {
        headers: {
          Authorization: `Bearer ${params.token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const GetBrowseProjects = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/client-Project-List`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_freelancer_active_orders = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/freelancer_bid_accept`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOpenRequest = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/disputes`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMyProposals = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/freelancer-proposals`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_order_showcase = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/freelancer_showcase_order`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const delete_bid = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/bid_delete`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const update_offer_freelancer = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/bid_accept_reject`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateClientInvitation = async (formData, token) => {
  // https://protalz.com/admin/api/invitation_accept_reject 
  try {
    const response = await axios.post(`${APP_BASE_URL}/invitation_accept_reject`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw error
  }
}

export const getFreelancers = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/freelancers`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getShowcasesList = async (formData) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase-category-projects`,
      formData,
      // `${APP_BASE_URL}/services-project`, formData,
      // {
      //   headers: {
      //     Authorization: `Bearer ${token}`, // Add Bearer token here
      //   },
      // }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getServiceShowcaseList = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase-services-project`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMyProjectInvitation = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response

  } catch (error) {
    throw error
  }
}

// export const getShowcasesList = async (formData, token) => {
//     try {
//         const response = await axios.post(
//             `${APP_BASE_URL}/categoryShowcaseList`, formData,
//             {
//                 headers: {
//                     Authorization: `Bearer ${token}`, // Add Bearer token here
//                 },
//             }
//         ); return response;
//     } catch (error) {
//         throw error;
//     }
// }

export const getshowcasData = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcaseDetail`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getShowcasePlan = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/plan_showcase`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const showcaseLike = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/like_showcase`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const submitShowcaseOrder = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase_orders`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const reqSubmitShowcaseOrder = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase_requirement_submit`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const milestone_submit = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/create_milestone`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const update_mile_status = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/status_update_milestone`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_showcase_order_detail = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase_order_detail`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const start_showcase_order = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/start_showcase_order`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const mark_missing_details = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/missing_showcase_details`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const showcase_delivery = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase_delivery`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const showcase_delivery_approval = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase_delivery_approval`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const showcase_revision = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/showcase_revision`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateReview = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/submit_reviews`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// certificationss

export const exam_list = async (formData, token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/exam-list`, formData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const get_questions = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/questions-list`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const submit_certificate_answers = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/submit-answers`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// dispute section
export const get_dispute_data = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/dispute_milestones`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProjectsandUsers = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/get-projects-users`, {
      headers: {
        Authorization: `Bearer ${token}`, // Add Bearer token here
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const dispute_create = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/create_dispute`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createProjectDispute = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/create-project-dispute`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDispute = async (id, token) => {
  try {
    const response = await axios.get(
      `${APP_BASE_URL}/get-single-dispute/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const offer_Dispute = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/offer-dispute`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const acceptRejectOffer = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/offer-accept-reject`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProjectDisputes = async (
  type,
  token,
  page,
  pageSize,
  search
) => {
  try {
    const response = await axios.get(
      `${APP_BASE_URL}/get-project-disputes?type=${type}&page=${page}&pageSize=${pageSize}&search=${search}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const payArbitition = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/pay-arbitration-fee`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const dispute_cancel = async (id, token) => {
  try {
    const response = await axios.delete(
      `${APP_BASE_URL}/cancel-dispute/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const reply_to_dispaute = async (formData, token) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/reply-to-dispute`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Add Bearer token here
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// header search
// ppppp
export const getSearchData = async (
  type,
  search,
  category_id,
  minPrice,
  maxPrice,
  deliveryTime,
  serviceDetails
) => {
  try {
    const params = {
      type,
      search,
    };

    if (category_id) params.category_id = category_id;
    if (minPrice) params.minPrice = minPrice;
    if (maxPrice) params.maxPrice = maxPrice;
    if (deliveryTime) params.deliveryTime = deliveryTime;
    if (serviceDetails && serviceDetails.length > 0) {
      params.serviceDetails = JSON.stringify(serviceDetails);
    }

    const queryString = new URLSearchParams(params).toString();
    const url = `${APP_BASE_URL}/search?${queryString}`;

    const response = await axios.get(url);
    console.log("API Response --->", response);
    return response;
  } catch (error) {
    console.error("API Error --->", error);
    throw error;
  }
};

// get freenlancer hires

export const getFreelancersHiresData = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/hired`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// recent view by client of freelancer
export const clientRecentViews = async (token, formData) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/recent_view`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// add to favourite by client of freelancer

export const clientAddTofavourite = async (token, id) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/freelancer_favourite_profile`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getClientFavouriteFreelancer = async (token) => {
  try {
    const response = await axios.get(
      `${APP_BASE_URL}/freelancer_favourite_view_list`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// get recent views for cleint and freelancer
export const getRecentviews = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/recent_view_list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const SubmitSavedProjectByClient = async (token, project_id) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/saved_project`,
      { project_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getSavedProjectsByClient = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/saved_project_list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const InviteFreelancerByClient = async (token, project_id, freelancer_id) => {
  try {
    const response = await axios.post(
      `${APP_BASE_URL}/invite_freelancer`,
      { project_id, freelancer_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const GetInviteFreelancer = async (token, formData) => {
  console.log("show tokeennnn and for Data---->", token, formData);

  try {
    const response = await axios.post(`${APP_BASE_URL}/invite_freelancer_list`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    // console.log("show invite freelnacer ----------->",response);

    return response.data
  } catch (error) {
    // console.log("show api fetch error --->",error);

    throw error
  }
}

export const SendCounterOffer = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/counter_offer`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw error
  }
}

export const CounterOfferAcceptReject = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/counter-offer`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw error
  }
}

export const GetSavedShowCases = async (token) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/showcaseLikes`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    // console.log("shw response from get saved showcase projecst", response);

    return response
  } catch (error) {
    throw error
  }
}
export const AcceptAndRejectCounterOffer = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/counter-offer-accept-reject`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    console.log("show response from counteroffer api ---->", response.data);

    return response;
  } catch (error) {
    throw error
  }
}

// Financial dashboard 
export const GetFinancialDashBoard = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/financial-dashboard`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    console.log("show respose from finanival milestoness", response);

    return response
  } catch (error) {
    throw error
  }
}

export const GetFaq = async (formData) => {
  try {
    // const response = await axios.post(`${APP_BASE_URL}/getFaqs`, formData, {
    //   headers: {
    //     Authorization: `Bearer ${token}`
    //   }
    // })
    const response = await axios.post(`${APP_BASE_URL}/getFaqs`, formData)
    console.log("show get faq from Base url file----->", response);

    return response.data.data
  } catch (error) {
    throw error
  }
}
export const CreateInvoice = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/invoice`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw error
  }
}

export const GetInvoices = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/invoice_list`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw error
  }
}

export const GeFundTransferProjects = async (token) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/getFundsProject`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response;
  } catch (error) {
    throw error
  }
}


export const createfreelancerAvailability = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/changePorfolioStatus`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }

    })
    return response
  } catch (error) {
    throw error
  }
}

export const getFreelancerShowcaseDetails = async (query) => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/user-based-showcases`, { params: query });
    return response
  } catch (error) {
    throw error
  }
}
export const getViewShowDetails = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/freelance/details`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getFreelancerShowCaseReviews = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/freelancer/showcase/review`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response

  } catch (error) {
    throw error
  }
}


export const FetchCountries = async () => {
  try {
    const response = await axios.get(`${APP_BASE_URL}/fetchCountries`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const TransactionHistory = async (token, formData, page) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/transaction-history?page=${page}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw error
  }
}

export const GetMileStons = async (token, page) => {
  try {

    const response = await axios.post(`${APP_BASE_URL}/get-milestone?page=${page}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } catch (error) {
    throw error
  }

}

export const SendChatReqest = async (token, formData) => {
  try {
    const response = await axios.post(`${APP_BASE_URL}/chatFreelancer`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data;
  } catch (error) {

  }
}

// ppppp

const authHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`
  }
});

export const hourlySummary = async (token, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/summary`, formData, authHeaders(token));
  return response.data;
};

export const hourlyContractSettings = async (token, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/contract-settings`, formData, authHeaders(token));
  return response.data;
};

export const hourlyFundWeeklyEscrow = async (token, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/fund-weekly-escrow`, formData, authHeaders(token));
  return response.data;
};

export const hourlyStart = async (token, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/start`, formData, authHeaders(token));
  return response.data;
};

export const hourlyHeartbeat = async (token, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/heartbeat`, formData, authHeaders(token));
  return response.data;
};

export const hourlyStop = async (token, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/stop`, formData, authHeaders(token));
  return response.data;
};

export const hourlyDiary = async (token, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/diary`, formData, authHeaders(token));
  return response.data;
};

export const hourlyCreateInvoice = async (token, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/invoice`, formData, authHeaders(token));
  return response.data;
};

export const hourlyApproveInvoice = async (token, invoiceId) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/invoice/${invoiceId}/approve`, {}, authHeaders(token));
  return response.data;
};

export const hourlyRejectInvoice = async (token, invoiceId, reason = "") => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/invoice/${invoiceId}/reject`, { reason }, authHeaders(token));
  return response.data;
};

export const hourlyContractByProject = async (token, projectId) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/contract/${projectId}`, {}, authHeaders(token));
  return response.data;
};

export const hourlyFundContract = async (token, contractId, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/contract/${contractId}/fund`, formData, authHeaders(token));
  return response.data;
};

export const hourlyContractTimesheet = async (token, contractId, formData = {}) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/contract/${contractId}/timesheet`, formData, authHeaders(token));
  return response.data;
};

export const hourlyContractStart = async (token, contractId, formData = {}) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/contract/${contractId}/start`, formData, authHeaders(token));
  return response.data;
};

export const hourlyContractStop = async (token, contractId, formData = {}) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/contract/${contractId}/stop`, formData, authHeaders(token));
  return response.data;
};

export const hourlyManualTime = async (token, contractId, formData) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/contract/${contractId}/manual`, formData, authHeaders(token));
  return response.data;
};

export const hourlyApproveTimeLog = async (token, timeLogId) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/time-log/${timeLogId}/approve`, {}, authHeaders(token));
  return response.data;
};

export const hourlyRejectTimeLog = async (token, timeLogId, reason = "") => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/time-log/${timeLogId}/reject`, { reason }, authHeaders(token));
  return response.data;
};

export const hourlyDisputeTimeLog = async (token, timeLogId, reason = "") => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/time-log/${timeLogId}/dispute`, { reason }, authHeaders(token));
  return response.data;
};

export const hourlyGenerateWeeklyInvoice = async (token, contractId) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/contract/${contractId}/invoice`, {}, authHeaders(token));
  return response.data;
};

export const hourlyReleaseInvoice = async (token, invoiceId) => {
  const response = await axios.post(`${APP_BASE_URL}/hourly/invoice/${invoiceId}/release`, {}, authHeaders(token));
  return response.data;
};
